import { Server } from "@wajeez/wajeez.microservices";
import { ChevronLeft } from "lucide-react";
import { SVG } from "@components/items/common/SVG";
import TranslatedText from "@components/items/display/TranslatedText";
import { Badge } from "@ui/badge";
import { ShadcnButton } from "@components/items/display/ShadcnButton";
import { GenericLoading } from "@components/items/common/GenericLoading";
import AddPlaylistDialog from "../b2c/my-corner/AddPlaylistDialog";
import PlaylistCard from "@components/items/display/PlaylistCard";
import useCurrentPlan from "@utils/hooks/useCurrentPlan";
import { translate } from "@modules/localizations/translate";
import React from "react";
import { HorizontalListSkeleton } from "./HorizontalListSkeleton";

type NewType = {
  icon: string;
  description?: string;
  title?: string;
  // buttonText?: string;
  // onButtonClick?: () => void;
};

interface PlaylistsSectionProps {
  contents: Server.PlaylistOutput[];
  badge: {
    title: string;
    icon: string;
    style: string;
  };
  noContent: NewType;
  countTitle: string | JSX.Element;
  onItemPress?:
    | ((item: Server.PlaylistOutput) => void | Promise<void>)
    | undefined;
  isLoading?: boolean;
  onSeeMoreClick?: () => void;
  setIsCreatePlaylistDialogOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const MAX = 5;

export const PlaylistsSection = ({
  contents,
  badge,
  noContent,
  countTitle,
  onItemPress,
  isLoading,
  onSeeMoreClick,
  setIsCreatePlaylistDialogOpen,
}: PlaylistsSectionProps) => {
  const visibleItems = contents.slice(0, MAX);
  const { plan } = useCurrentPlan();

  return (
    <div className="flex w-full flex-col items-start justify-center gap-3 p-5 pb-10 text-black dark:text-white">
      <div className="flex w-full items-center justify-between px-3">
        <Badge className={`py-1 text-black ${badge.style}`}>
          <div className="flex items-center justify-center gap-2">
            <div>
              <SVG src={badge.icon} className="h-5 w-5" />
            </div>
            <div>{badge.title}</div>
          </div>
        </Badge>
        {!plan?.isFree && visibleItems.length > 0 && <AddPlaylistDialog />}
      </div>
      {contents.length ? (
        <>
          <div className="flex w-full items-center justify-between px-3">
            <div className="flex items-center justify-start gap-2">
              {countTitle}
            </div>
            {contents.length > MAX ? (
              <div
                className="flex cursor-pointer items-center justify-center gap-1"
                onClick={onSeeMoreClick}
              >
                <TranslatedText
                  text={`my-library.${"show all"}`}
                  className="flex cursor-pointer items-center justify-center hover:opacity-75"
                />
                <ChevronLeft strokeWidth={1.5} className="ltr:rotate-180" />
              </div>
            ) : null}
          </div>
          <div className="flex w-full items-start justify-start gap-4">
            {visibleItems.map((item) => {
              return (
                <PlaylistCard
                  key={item.id}
                  item={item}
                  onClick={() => {
                    onItemPress && onItemPress(item);
                  }}
                />
              );
            })}
          </div>
        </>
      ) : !isLoading ? (
        <div className="flex w-full flex-col items-center justify-center gap-2 py-6">
          <SVG src={noContent.icon} />
          <div className="text-[20px] font-medium text-black dark:text-white">
            {noContent.title}
          </div>
          <div className="flex flex-col items-center justify-center gap-4">
            {noContent.description}
            {plan?.isFree ? (
              <a
                href={
                  "https://pay.wajeez.com/?content=registerMethod&subscriptionType=P1Y"
                }
                rel="noopener noreferrer"
              >
                <ShadcnButton className="rounded-xl bg-primary text-white">
                  {translate(
                    "my-library.playlists no content button text freemium"
                  )}
                </ShadcnButton>
              </a>
            ) : (
              <ShadcnButton
                className="rounded-xl bg-primary text-white"
                onClick={() => {
                  setIsCreatePlaylistDialogOpen &&
                    setIsCreatePlaylistDialogOpen(true);
                }}
              >
                {translate(
                  "my-library.playlists no content button text premium"
                )}
              </ShadcnButton>
            )}
            {/* {noContent.buttonText ? (
              <ShadcnButton
                className="rounded-xl bg-primary text-white"
                onClick={noContent.onButtonClick}
              >
                {noContent.buttonText}
              </ShadcnButton>
            ) : null} */}
          </div>
        </div>
      ) : (
        <HorizontalListSkeleton />
      )}
    </div>
  );
};

export default PlaylistsSection;
